export default {
    formData: {
        personalInformation: {},
        benefit: {},
        familyMembers: [{}],
        myAssessments: [],
        partnerAssessments: []
    },
    formSummary: [],
    formConditionals: {
        benefitAction: undefined
    },
    isLoading: false
}